import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss']
})
export class TermsDialogComponent implements AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  hasScrolledToBottom = false;

  constructor(public dialogRef: MatDialogRef<TermsDialogComponent>) {}

  ngAfterViewInit() {
    // We check if the content is small enough that it doesn't need scrolling
    this.checkScroll();
  }

  onScroll(event: any) {
    const element = event.target;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const threshold = element.scrollHeight - 10; // 10px buffer

    if (scrollPosition >= threshold) {
      this.hasScrolledToBottom = true;
    }
  }

  private checkScroll() {
    // Delay slightly to ensure layout is complete
    setTimeout(() => {
      const element = this.scrollContainer.nativeElement;
      if (element.scrollHeight <= element.clientHeight) {
        this.hasScrolledToBottom = true;
      }
    }, 100);
  }

  accept() {
    if (this.hasScrolledToBottom) {
      this.dialogRef.close(true);
    }
  }

  decline() {
    this.dialogRef.close(false);
  }
}
